import { render, staticRenderFns } from "./NewContact.vue?vue&type=template&id=7d502be8&scoped=true&"
import script from "./NewContact.vue?vue&type=script&lang=ts&"
export * from "./NewContact.vue?vue&type=script&lang=ts&"
import style0 from "./NewContact.vue?vue&type=style&index=0&id=7d502be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d502be8",
  null
  
)

export default component.exports